import type { SVGProps } from "react";

type PraxaWorkspaceNavigationIconProps = SVGProps<SVGSVGElement>;

const HOME_ACTIVE_PATH =
  "M9.59.92a3.63 3.63 0 0 1 4.82 0l7.25 6.44A4 4 0 0 1 23 10.35v8.46a3.9 3.9 0 0 1-3.6 3.92 106 106 0 0 1-14.8 0A3.9 3.9 0 0 1 1 18.8v-8.46a4 4 0 0 1 1.34-3zM12 16a5 5 0 0 1-3.05-1.04l-1.23 1.58a7 7 0 0 0 8.56 0l-1.23-1.58A5 5 0 0 1 12 16";

const HOME_INACTIVE_PATH =
  "M4.6 22.73A107 107 0 0 0 11 23h2.22c2.43-.04 4.6-.16 6.18-.27A3.9 3.9 0 0 0 23 18.8v-8.46a4 4 0 0 0-1.34-3L14.4.93a3.63 3.63 0 0 0-4.82 0L2.34 7.36A4 4 0 0 0 1 10.35v8.46a3.9 3.9 0 0 0 3.6 3.92M13.08 2.4l7.25 6.44a2 2 0 0 1 .67 1.5v8.46a1.9 1.9 0 0 1-1.74 1.92q-1.39.11-3.26.19V16a4 4 0 0 0-8 0v4.92q-1.87-.08-3.26-.19A1.9 1.9 0 0 1 3 18.81v-8.46a2 2 0 0 1 .67-1.5l7.25-6.44a1.63 1.63 0 0 1 2.16 0M13.12 21h-2.24a1 1 0 0 1-.88-1v-4a2 2 0 1 1 4 0v4a1 1 0 0 1-.88 1";

const CUSTOMIZE_PATH =
  "M8.99998 17.298C8.99998 16.082 8.01416 15.096 6.79803 15.096C5.5819 15.096 4.59608 16.082 4.59608 17.298C4.59608 18.5141 5.5819 19.5 6.79803 19.5C8.01416 19.5 8.99998 18.5141 8.99998 17.298ZM19.5 17.298C19.5 16.082 18.5141 15.096 17.298 15.096C16.082 15.096 15.096 16.082 15.096 17.298C15.096 18.5141 16.082 19.5 17.298 19.5C18.5141 19.5 19.5 18.5141 19.5 17.298ZM8.99998 6.79805C8.99998 5.58192 8.01416 4.5961 6.79803 4.5961C5.5819 4.5961 4.59608 5.58192 4.59608 6.79805C4.59608 8.01418 5.5819 9 6.79803 9C8.01416 9 8.99998 8.01418 8.99998 6.79805ZM19.5 6.79805C19.5 5.58192 18.5141 4.5961 17.298 4.5961C16.082 4.5961 15.096 5.58192 15.096 6.79805C15.096 8.01418 16.082 9 17.298 9C18.5141 9 19.5 8.01418 19.5 6.79805ZM21.096 17.298C21.096 19.3956 19.3956 21.096 17.298 21.096C15.2004 21.096 13.5 19.3956 13.5 17.298C13.5 15.2004 15.2004 13.5 17.298 13.5C19.3956 13.5 21.096 15.2004 21.096 17.298ZM10.5961 6.79805C10.5961 8.89562 8.89561 10.5961 6.79803 10.5961C4.70046 10.5961 2.99998 8.89562 2.99998 6.79805C2.99998 4.70047 4.70046 3 6.79803 3C8.89561 3 10.5961 4.70047 10.5961 6.79805ZM21.096 6.79805C21.096 8.89562 19.3956 10.5961 17.298 10.5961C16.538 10.5961 15.8316 10.3701 15.2379 9.98555L9.98553 15.2379C10.3701 15.8316 10.5961 16.538 10.5961 17.298C10.5961 19.3956 8.89561 21.096 6.79803 21.096C4.70046 21.096 2.99998 19.3956 2.99998 17.298C2.99998 15.2004 4.70046 13.5 6.79803 13.5C7.55756 13.5 8.26351 13.7253 8.85702 14.1094L14.1094 8.85703C13.7253 8.26352 13.5 7.55758 13.5 6.79805C13.5 4.70047 15.2004 3 17.298 3C19.3956 3 21.096 4.70047 21.096 6.79805Z";

function NavigationIcon({
  path,
  ...props
}: PraxaWorkspaceNavigationIconProps & { readonly path: string }) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      focusable="false"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d={path} fill="currentColor" strokeWidth={0} />
    </svg>
  );
}

export function PraxaOverviewNavigationIcon({
  active,
  ...props
}: PraxaWorkspaceNavigationIconProps & { readonly active: boolean }) {
  return <NavigationIcon {...props} path={active ? HOME_ACTIVE_PATH : HOME_INACTIVE_PATH} />;
}

export function PraxaCustomizeNavigationIcon(props: PraxaWorkspaceNavigationIconProps) {
  return <NavigationIcon {...props} path={CUSTOMIZE_PATH} />;
}
